import { Injectable, Injector } from '@angular/core';

import { ValidatorRemoteService } from './validator-remote.service';
import { RegexValidatorPatternService } from './regex-validator-pattern.service';

import { ControlValidatorType, ControlValidatorBase, ValidatorBindModel } from '../types/validator.types';
import { AbstractControl } from '../types/control.types';

import { RequiredControlValidator } from '../validators/validators/required-control-validator';
import { UniqueControlValidator } from '../validators/validators/unique-control-validator';
import { StringLengthControlValidator } from '../validators/validators/string-length-control-validator';
import { RegexControlValidator } from '../validators/validators/regex-control-validator';
import { DigitalRangeValidator } from '../validators/validators/digital-range-validator';
import { DigitalTypeValidator } from '../validators/validators/digital-type-validator';
import { FileUploadFileTypeControlValidator } from '../validators/validators/file-upload-file-type-control-validator';
import { FileUploadFileSizeControlValidator } from '../validators/validators/file-upload-file-size-control-validator';
import { RegexControlInternalValidator } from '../validators/validators/regex-control-internal-validator';
import { UnionCHeckValidator } from '../validators/validators/union-check-validators';

import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';

@Injectable({ providedIn: 'root' })
export class ControlValidatorService {
  constructor(private injector: Injector, private config: DynamicFormDesignerConfig) {
    this.controlValidators.push(...this.config.bindValidator());
  }

  /**
   * @description æ§ä»¶éªè¯å¨
   *
   * @memberof ControlValidatorService
   */
  controlValidators: Array<ValidatorBindModel> = [
    { key: ControlValidatorType.Required, value: RequiredControlValidator },
    {
      key: ControlValidatorType.Unique,
      value: UniqueControlValidator,
      factory: (service: ValidatorRemoteService) => {
        return new UniqueControlValidator(service);
      },
      deps: [ValidatorRemoteService]
    },
    { key: ControlValidatorType.StringLength, value: StringLengthControlValidator },
    {
      key: ControlValidatorType.RegularExpression,
      value: RegexControlValidator,
      factory: (service: RegexValidatorPatternService) => {
        return new RegexControlValidator(service);
      },
      deps: [RegexValidatorPatternService]
    },
    {
      key: ControlValidatorType.RegularExpressionInternal,
      value: RegexControlInternalValidator,
      factory: (service: RegexValidatorPatternService) => {
        return new RegexControlInternalValidator(service);
      },
      deps: [RegexValidatorPatternService]
    },

    { key: ControlValidatorType.DigitalRange, value: DigitalRangeValidator },
    { key: ControlValidatorType.DigitalType, value: DigitalTypeValidator },
    { key: ControlValidatorType.FileTypeOfUpload, value: FileUploadFileTypeControlValidator },
    { key: ControlValidatorType.FileSizeOfUpload, value: FileUploadFileSizeControlValidator },
    { key: ControlValidatorType.UnionCheck, value: UnionCHeckValidator }
  ];

  /**
   * @description è·åæ§ä»¶éªè¯å¨
   *
   * @param type æ§ä»¶ç±»å
   * @param control è¦å³èçæ§ä»¶
   * @param model éªè¯å¨çmodel
   * @returns ä¸ä¸ªéªè¯å¨
   * @memberof ControlValidatorService
   */
  getControlValidator(type: string, control?: AbstractControl<any>, model?: any): ControlValidatorBase {
    const rule = this.getControlValidatorByType(type, control);
    if (!rule) {
      return rule;
    }
    rule.model = model;
    return rule;
  }

  /**
   * @description æ ¹æ®éªè¯å¨ç±»åè·åéªè¯å¨
   *
   * @param type æ§ä»¶ç±»å
   * @param control è¦å³èçæ§ä»¶
   * @returns ä¸ä¸ªéªè¯å¨
   * @memberof ControlValidatorService
   */
  getControlValidatorByType(type: string, control?: AbstractControl<any>): ControlValidatorBase {
    let validator: ControlValidatorBase;
    const validatorType = this.controlValidators.find((s) => s.key === type);
    if (validatorType && validatorType.value) {
      let injector = this.getInject(type);
      validator = injector.get<ControlValidatorBase>(validatorType.value);
      injector = undefined;
      validator.control = control;
    }
    return validator;
  }

  /**
   * @description è·åæ³¨å¥å¨ï¼è¿ç§æ¹å¼å¯ä»¥ä¿è¯æ¯æ¬¡æ¯æ°å»ºä¸ä¸ªéªè¯å¨çå®ä¾
   *
   * @param key éªè¯å¨ç±»å
   * @returns å½å¦éªè¯å¨çæ³¨å¥å¨
   * @memberof ControlValidatorService
   */
  getInject(key: string): Injector {
    const providers = this.controlValidators
      .filter((s) => s.key === key && !!s.value)
      .map((s) => {
        return {
          provide: s.value,
          useFactory: s.factory
            ? s.factory
            : () => {
                return new s.value();
              },
          deps: s.deps ? s.deps : []
        };
      });
    return Injector.create({ providers: providers, parent: this.injector });
  }
}
